export default __webpack_public_path__ + "static/media/empty-meter.c6b8072d.svg";